import { createApi } from '@reduxjs/toolkit/query/react'; 
import { getBaseQuery } from '../../Utils';

interface SSOSignInRequest {
    OpenIdLoginURL: string;
    OpenIdRedirectURL: string;
    scope: string;
    client_id: string;
    state: string;
}

interface SSOSignInResponse {
    data: SSOSignInRequest;
}

export const ssoSignInApi = createApi({
    reducerPath: "ssoSignInApi",
    baseQuery: getBaseQuery(  '/api/v3/account/' ),
    endpoints: (builder) => ({
    getSSOLogin: builder.query<SSOSignInResponse, void>({
      query: () => 'SSOLogin',
    }),
  }),
});

export const { useLazyGetSSOLoginQuery } = ssoSignInApi;